//@ts-check
import React, { useState, useRef, useEffect } from "react"
import { useTranslation } from "react-i18next"
import DeleteIcon from "@material-ui/icons/Delete"
import CheckIcon from "@material-ui/icons/Check"
import ClearIcon from "@material-ui/icons/Clear"
import BlockIcon from "@material-ui/icons/Block"
const CONSTS = require("shared/consts")
import MUITooltip from "@material-ui/core/Tooltip"
import store from "../store"
import {
  AddIcon,
  DownIcon,
  DuplicateIcon,
  EditIcon,
  MoveDownIcon,
  MoveUpIcon,
  RightArrowIcon,
} from "./icons-svg"
import { invalidColor, isStepValidated } from "../validations"
import StepToTitle from "./step-to-title"
import {
  EXPLAIN_FAIL_WHILE_TRANSACTION_SUCCESS,
  EXPLAIN_PASS_WHILE_TRANSACTION_FAILED,
} from "shared/consts"
import InlineConfirmation from "./inline-confirmation"
import StepViewEdit from "./step-view-edit"
import { useStepIndex } from "./step-index-context"
import { getSimulationURL } from "src/utils/get-simulation-library-url"
import useHistory from "src/use-history"
import Tooltip from "./tooltip"
import CPopper from "./cPopper"
import AddStepButtons from "./add-step-buttons"

/**
 * @param object {Object}
 * @param [object.step] {import("../../../backend/interfaces").Step}
 * @param object.onDelete {any}
 * @param object.onDuplicate {any}
 * @param object.showMoveUp, {any}
 * @param object.showMoveDown, {any}
 * @param object.moveUp, {any}
 * @param object.moveDown, {any}
 * @param object.isSelected, {number}
 * @param object.onClick {()=>{}}
 * @param object.showLines {boolean}
 * @param object.onMoveStep {any}
 * @param object.onAddStep {any}
 */

function StepCollapsed({
  onClick,
  onDelete,
  onDuplicate,
  isSelected,
  showLines,
  onMoveStep,
  onAddStep,
}) {
  const history = useHistory()
  const { t } = useTranslation()
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [newName, setNewName] = useState(null)
  const [isHovered, setIsHovered] = useState(false)
  var stepIndex = useStepIndex()
  const isEditingName = typeof newName === "string"
  const renameFieldRef = useRef(null)
  const [anchorElPopper, setAnchorElPopper] = React.useState(null)

  const handleAddStepClick = (event) => {
    setAnchorElPopper(anchorElPopper ? null : event.currentTarget)
  }

  const openPopper = Boolean(anchorElPopper)

  useEffect(() => {
    if (isEditingName) {
      renameFieldRef?.current?.focus()
    }
  }, [newName])

  store.useRerenderIfChange(() => [
    // store.results
    store.steps[stepIndex]?.skip,
    store.steps[stepIndex]?.collapsed,
  ])

  var step = store.steps[stepIndex]

  if (stepIndex >= store.steps.length) {
    return null
  }

  /** @type {import("../../../backend/interfaces").ABIField}*/
  // @ts-ignore
  var parameters = {}
  if (step.type == CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT) {
    parameters = step.abi.find((abiItem) => abiItem.type == "constructor")
  } else if (step.type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION) {
    parameters = step?.abi?.find(
      (abiItem) => abiItem.name == step.function_name,
    )
  } else {
    // return <div>step type {step.type} not supported yet</div>
  }

  var rightSideStyle = {
    marginRight: 8,
    flexShrink: 0,
  }

  const iconStyle = {
    fontSize: "0.75rem",
    verticalAlign: "middle",
  }

  const indicatorIconStyle = {
    ...iconStyle,
    fontSize: "1.25rem",
  }

  const passFailIconBoxStyle = {
    height: "100%",
    paddingLeft: 4,
    display: "flex",
    alignItems: "center",
  }

  const emptyBoxStyle = {
    ...passFailIconBoxStyle,
    padding: "6px 6px 5px 5px",
  }

  var rightSideButtons = [
    {
      id: "move_step_up_btn",
      tip: t("buttons.move_step_up"),
      element: MoveUpIcon(20),
      onClick: (e) => {
        onMoveStep(stepIndex, "up")
      },
    },
    {
      id: "move_step_down_btn",
      tip: t("buttons.move_step_down"),
      element: MoveDownIcon(20),
      onClick: (e) => {
        onMoveStep(stepIndex, "down")
      },
    },
    {
      id: "duplicate_btn",
      tip: "Duplicate",
      element: DuplicateIcon(14),
      onClick: onDuplicate,
    },
    {
      id: "delete_btn",
      tip: t("buttons.delete_step"),
      element: (
        <DeleteIcon
          css={`
            font-size: 14px;
            cursor: pointer;
          `}
        />
      ),
      onClick: (e) => {
        setAnchorEl(e.currentTarget)
        setShowDeleteConfirmation(true)
      },
    },
  ]

  var isDefaultStep = step["defaultStep"]

  var thisStepOutput = store.results?.length
    ? store.results[store.currentResult]?.steps_output?.find(
        (x) => x.uid == step.uid,
      )
    : null
  var showV = !step.skip && !store.isLoadingResults && thisStepOutput?.success
  var showX =
    !step.skip && !store.isLoadingResults && thisStepOutput?.success === false
  var showNothing = !showV && !showX && !step.skip

  var isOneSide = store.getView() == "oneside"
  // const validated = isStepValidated(stepNumber - 1)
  var validated = true // do not mark unvalidated steps in red. For imporving performance

  const goToEditInitializationStep = async () => {
    history.push(
      getSimulationURL({
        simulationId: store.selectedReviewData.defaultStepSimulationId,
        engagement_id: store.selectedReviewData.engagementData._id,
        review_id: store.selectedReviewData._id,
      }),
    )
  }

  return (
    <div>
      {showDeleteConfirmation && (
        <>
          <div
            css={`
              display: flex;
              align-items: center;
              /* justify-content: space-between;  */
              justify-content: flex-end;
              padding: 4px;
              height: 70px;
              font-size: 0.75rem;
              background-color: ${validated ? "white;" : invalidColor};
              background-color: white;
              color: ${validated ? "unset" : "red"};
              border-style: solid;
              border-width: 1px;
              border-color: ${isSelected ? "#000" : "#F0F0F2"};
              font-weight: ${isSelected ? 400 : 300};
            `}
          >
            <InlineConfirmation
              message={"Are you sure you want to delete this step?"}
              cancelBtnText="No"
              onCancel={() => {
                setShowDeleteConfirmation(false)
              }}
              confirmationBtnText="Yes"
              onConfirm={() => {
                setShowDeleteConfirmation(false)
                onDelete()
              }}
            />
          </div>
        </>
      )}
      {!showDeleteConfirmation && (
        <div
          css={`
            position: relative;
          `}
          onMouseEnter={() => {
            if (!step["defaultStep"]) {
              setIsHovered(true)
            }
          }}
          onMouseLeave={(e) => {
            if (!step["defaultStep"]) {
              setIsHovered(false)
              setAnchorElPopper(null)
            }
          }}
        >
          {!step["defaultStep"] && (
            <>
              {isHovered ? (
                <>
                  <div
                    style={{
                      left: 0,
                      position: "absolute",
                      right: 0,
                      top: "-16px",
                      margin: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    aria-describedby={
                      openPopper ? "transitions-popper" : undefined
                    }
                    onClick={handleAddStepClick}
                  >
                    {AddIcon(16)}
                  </div>
                  <CPopper
                    anchorEl={anchorElPopper}
                    open={openPopper}
                    content={<AddStepButtons stepIndex={stepIndex} />}
                  />
                </>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    left: 0,
                    position: "absolute",
                    right: 0,
                    top: "-16px",
                    margin: "auto",
                  }}
                  onMouseEnter={() => {
                    setIsHovered(true)
                  }}
                  onMouseLeave={() => {
                    setIsHovered(false)
                    setAnchorElPopper(null)
                  }}
                ></div>
              )}
            </>
          )}

          <div
            css={`
              height: 70px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              font-size: 0.75rem;
              background-color: ${isDefaultStep ? "#cbcbcb" : "white"};
              color: ${validated ? "unset" : "red"};
              border-style: solid;
              border-width: 1px;
              border-color: ${isSelected && !isOneSide ? "#000" : "#F0F0F2"};
              font-weight: ${isSelected && !isOneSide ? 400 : 300};
            `}
            onClick={onClick}
          >
            {isOneSide && (
              <>
                {step.collapsed && <div>{RightArrowIcon()}</div>}
                {!step.collapsed && <div>{DownIcon()}</div>}
              </>
            )}

            {showNothing && (
              <div css={"visibility:hidden;"} style={passFailIconBoxStyle}>
                <CheckIcon style={indicatorIconStyle} />
              </div>
            )}
            {showV && (
              <div css={"color:green"} style={passFailIconBoxStyle}>
                <CheckIcon style={indicatorIconStyle} />
              </div>
            )}
            {showX && (
              <div css={"color:red"} style={passFailIconBoxStyle}>
                <ClearIcon style={indicatorIconStyle} />
              </div>
            )}
            {step.skip && (
              <div css={"color:orange"} style={passFailIconBoxStyle}>
                <BlockIcon style={indicatorIconStyle} />
              </div>
            )}
            {thisStepOutput &&
              showV &&
              thisStepOutput.pass_expections === false && (
                <Tooltip title={EXPLAIN_FAIL_WHILE_TRANSACTION_SUCCESS}>
                  <span
                    css={`
                      color: red;
                      cursor: default;
                    `}
                  >
                    &nbsp;FAIL
                  </span>
                </Tooltip>
              )}
            {thisStepOutput && showX && thisStepOutput.pass_expections && (
              <Tooltip title={EXPLAIN_PASS_WHILE_TRANSACTION_FAILED}>
                <span
                  css={`
                    color: green;
                    cursor: default;
                  `}
                >
                  &nbsp;PASS
                </span>
              </Tooltip>
            )}

            {!store.isStepReadOnly(stepIndex) && !isDefaultStep && (
              <div className="handle">
                <Handle />
              </div>
            )}
            <div
              css={`
                opacity: 0.7;
                font-weight: ${isSelected ? 700 : undefined};
                font-size: 12px;
                background: black;
                color: white;
                width: 21px;
                text-align: center;
                padding: 3px;
                border-radius: 50%;
              `}
            >
              {stepIndex + 1 ? stepIndex + 1 + " " : ""}
            </div>
            <div
              css={`
                flex-grow: 1;
                padding-left: 5px;
                cursor: ${isSelected ? "default" : "pointer"};
                overflow: hidden;
                user-select: none;
                text-overflow: ellipsis;
                white-space: nowrap;
              `}
            >
              <StepToTitle step={step} />
            </div>
            {isDefaultStep && (
              <div
                css={`
                  font-weight: 700;
                  margin-right: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                `}
              >
                Initialization Step
                <Tooltip title="Edit initialization step">
                  <span
                    css="cursor: pointer; margin-left: 10px;"
                    onClick={() => {
                      goToEditInitializationStep()
                    }}
                  >
                    {" "}
                    {EditIcon(14)}
                  </span>
                </Tooltip>
              </div>
            )}
            {!store.isStepReadOnly(stepIndex) &&
              !isDefaultStep &&
              rightSideButtons.map((button, index) => {
                if (stepIndex == 0 && button.id === "move_step_up_btn") {
                  return null
                } else if (
                  stepIndex == store.steps.length - 1 &&
                  button.id === "move_step_down_btn"
                ) {
                  return null
                } else if (
                  store.steps[stepIndex - 1]?.["defaultStep"] &&
                  button.id === "move_step_up_btn"
                ) {
                  return null
                } else if (step["defaultStep"]) {
                  return null
                } else {
                  return (
                    <div key={button.id}>
                      <MUITooltip
                        //@ts-ignore
                        arrow
                        placement="top"
                        title={button.hide ? "" : button.tip}
                        aria-label={button.hide ? "" : button.tip}
                      >
                        <div
                          onClick={(e) => {
                            e.stopPropagation()
                            button.onClick(e)
                          }}
                        >
                          {button.element}
                        </div>
                      </MUITooltip>
                    </div>
                  )
                }
              })}
          </div>
        </div>
      )}

      {store.getView() == "oneside" && !store.steps[stepIndex].collapsed && (
        <StepViewEdit />
      )}

      {stepIndex + 1 < store.steps.length && (
        <div
          className="step-splitter"
          css={`
            height: 15px;
            opacity: 0.7;
            width: 1px;
            background-color: ${showLines ? "black" : "none"};
            margin-left: 15px;
          `}
        />
      )}
    </div>
  )
}

function Handle() {
  return (
    <span
      css={`
        cursor: move;
        circle {
          fill: #555;
        }
      `}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.0//EN'  'http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd'>
  <svg style="vertical-align:middle;width:17px;" enable-background="new 0 0 24 24" id="Layer_1" version="1.0" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="12" cy="19" r="2"/></svg>`,
      }}
    />
  )
}
export default StepCollapsed
